export default __webpack_public_path__ + "static/media/nishant-logo.59eb209e.png";